import React from 'react';
import PropTypes from 'prop-types';
import { assets } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import UploadImageContainer from 'src/js/modules/common/containers/upload-image-container';
import ReplaceImageButton from 'src/js/modules/common/components/replace-image-button';
import MediaPreview from 'src/js/modules/common/components/media-preview';
import focalPoint from 'src/js/modules/focal-point';

const { IconButton } = designSystem;

const {
  constants: { common: focalPointConstants },
} = focalPoint;

const BlockBackgroundImageOption = ({
  optionId,
  captions,
  backgroundUrl,
  onCrop,
  onClick,
  onImageReplace,
  openSettings,
  onTriggerUploadImageClick,
  onTriggerBrowseStockPhotosClick,
  onWrongFileType,
  blockId,
  onImageUploadCancel = Function.prototype,
  isBackgroundPlaceholder = false,
  placeholderType = null,
}) => (
  <React.Fragment>
    <div className="ws-block-background">
      <MediaPreview
        placeholderType={placeholderType}
        backgroundSize="contain"
        url={isBackgroundPlaceholder ? '' : backgroundUrl}
      />
      {!isBackgroundPlaceholder && (
        <div className="ws-block-background__crop-control">
          <IconButton
            onClick={onCrop}
            glyph="crop"
            size="extra-large"
            label={captions.cropBtnTooltip}
          />
        </div>
      )}
      <div className="ws-block-background__replace-media-btn">
        <UploadImageContainer
          onImageUploadEnd={onImageReplace}
          onImageUploadCancel={onImageUploadCancel}
          preserveSharedData
          imagePlacement={assets.constants.IMAGE_PLACEMENTS.BACKGROUND}
        >
          {(imageContainerProps) => (
            <ReplaceImageButton
              id={optionId}
              label={isBackgroundPlaceholder ? captions.addMediaLabel : captions.replaceMediaLabel}
              elementId={blockId}
              accept={focalPointConstants.IMAGE_ACCEPT_TYPE}
              onPhotoStockDialogCancel={openSettings}
              {...imageContainerProps}
              onClick={onClick}
              onTriggerUploadImageClick={onTriggerUploadImageClick}
              onTriggerBrowseStockPhotosClick={onTriggerBrowseStockPhotosClick}
              onWrongFileType={onWrongFileType}
            />
          )}
        </UploadImageContainer>
      </div>
    </div>
  </React.Fragment>
);

BlockBackgroundImageOption.propTypes = {
  optionId: PropTypes.string.isRequired,
  captions: PropTypes.shape({
    replaceMediaLabel: PropTypes.string,
    addMediaLabel: PropTypes.string,
    cropBtnTooltip: PropTypes.string,
  }).isRequired,
  blockId: PropTypes.string.isRequired,
  backgroundUrl: PropTypes.string.isRequired,
  isBackgroundPlaceholder: PropTypes.bool,
  onCrop: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onImageReplace: PropTypes.func.isRequired,
  openSettings: PropTypes.func.isRequired,
  onTriggerUploadImageClick: PropTypes.func.isRequired,
  onTriggerBrowseStockPhotosClick: PropTypes.func.isRequired,
  onWrongFileType: PropTypes.func.isRequired,
  onImageUploadCancel: PropTypes.func,
  placeholderType: PropTypes.string,
};

export default BlockBackgroundImageOption;
